import React from 'react'

import GetStartedSmall from './GetStarted'
import GetStartedLarge from './GetStartedLarge'

const GetStarted = props => {
  const { large } = props
  const Component = large ? GetStartedLarge : GetStartedSmall
  return <Component {...props} />
}

export default GetStarted



// WEBPACK FOOTER //
// ./src/components/GetStarted/index.js